import { render, staticRenderFns } from "./SalesChannelModal.vue?vue&type=template&id=8cf5fcf2&"
import script from "./SalesChannelModal.vue?vue&type=script&lang=js&"
export * from "./SalesChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports